import { Dispatch } from 'redux';
import { AddFetchStatus, AddMessage, AddSuggestedQuestions } from '../redux/reducers/chatBotReducer';

interface FetchParams {
  value: string;
}

export const fetchSendMessages = (params: FetchParams) => {
  return async (dispatch: Dispatch) => {
    dispatch(AddFetchStatus({ loading: true }));

    try {
      const response = await fetch('https://myaskai.com/api/1.1/wf/ask-ai-chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: process.env.REACT_APP_API_ID,
          api_key: process.env.REACT_APP_API_KEY,
          feedback: document.location.origin,
          messages: [{ role: 'user', content: params.value }]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Network response was not ok');
      }

      dispatch(AddMessage({ text: data.answer, role: 'bot' }));
      dispatch(AddSuggestedQuestions(data.suggestedQuestions ?? data.suggested_questions));
      dispatch(AddFetchStatus({ status: response.status }));
    } catch (e) {
      if (e instanceof Error) {
        dispatch(AddFetchStatus({ status: e.message }));
      }
    } finally {
      dispatch(AddFetchStatus({ loading: false }));
    }
  };
};
